'use client';

/* eslint-disable @next/next/no-img-element -- The disclosure icon does not need the stateful shared Image fallback. */

import { useState, type ReactNode } from 'react';

interface ContactsDisclosureProps {
  buttonClassName: string;
  buttonLabel: string;
  children: ReactNode;
  iconClassName: string;
  listClassName: string;
  showButton: boolean;
}

export const ContactsDisclosure = ({
  buttonClassName,
  buttonLabel,
  children,
  iconClassName,
  listClassName,
  showButton,
}: ContactsDisclosureProps) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className={listClassName} data-expanded={expanded}>
      {children}
      {showButton && (
        <button
          aria-expanded={expanded}
          aria-label={buttonLabel}
          className={buttonClassName}
          onClick={() => setExpanded((current) => !current)}
          type="button"
        >
          <img
            alt=""
            aria-hidden="true"
            className={iconClassName}
            height={16}
            loading="lazy"
            src="/images/icons/indicator-lang.svg"
            width={16}
          />
        </button>
      )}
    </div>
  );
};
